import gql from 'graphql-tag';

export const getSongs = gql`
  query GET_SONGS($input: SongsInput) {
    songs(input: $input) {
      songs {
        id
        title
        albumArtworkSmUrl
        albumArtworkMdUrl
        albumArtworkLgUrl
        albumArtworkUrl
        artist
        createdAt
        versionCount
        defaultArtwork
        shareLink
      }
      startKey
    }
  }
`;

export const getPlaylists = gql`
  query GET_PLAYLISTS($input: PlaylistListInput) {
    playlists(input: $input) {
      startKey
      playlists {
        id
        title
        description
        albumArtworkUrl
        defaultArtwork
        songs {
          id
          versionCount
        }
      }
    }
  }
`;

export const getPlaylistsWithSongIds = gql`
  query GET_PLAYLISTS($input: PlaylistListInput) {
    playlists(input: $input) {
      startKey
      playlists {
        id
        title
        description
        albumArtworkUrl
        defaultArtwork
        songs {
          id
          versionCount
        }
      }
    }
  }
`;

export const getFiles = gql`
  {
    files {
      id
      title
      status
      cdnUrl
      downloadUrl
      optimizedUrl
      notes
      originalFilename
      bpm
      bpmCalculationStatus
      key
      keyScale
      keyCalculationStatus
      song {
        id
        title
        artist
      }
    }
  }
`;

export const getFileUrl = gql`
  query GetFileUrl($id: ID!) {
    file(input: { id: $id }) {
      cdnUrl
      downloadUrl
      optimizedUrl
    }
  }
`;

export const getFile = gql`
  query GetFile($id: ID!) {
    file(input: { id: $id }) {
      title
      optimizedUrl
      cdnUrl
      downloadUrl
      id
      active
      status
      notes
      originalFilename
      created
      bpm
      bpmCalculationStatus
      key
      keyScale
      keyCalculationStatus
    }
  }
`;

export const getPlaylist = gql`
  query GET_PLAYLIST($id: String!) {
    playlist(id: $id) {
      id
      title
      description
      albumArtworkUrl
      includeDescriptionWithShare
      defaultArtwork
      shareLink
      shareLinkAccess
      songs {
        id
        title
        artist
        bpm
        trackNumber
        albumArtworkUrl
        albumArtworkSmUrl
        shareLinkCreatedAt
        shareLink
        shareLinkAccess
        versionCount
        defaultArtwork
        files {
          title
          originalFilename
          optimizedUrl
          cdnUrl
          downloadUrl
          id
          active
          notes
          created
          bpm
          bpmCalculationStatus
          key
          keyScale
          keyCalculationStatus
        }
      }
    }
  }
`;

export const getPlaylistLight = gql`
  query GET_PLAYLIST($id: String!) {
    playlist(id: $id) {
      id
      title
      description
      albumArtworkUrl
      includeDescriptionWithShare
      defaultArtwork
      shareLink
      shareLinkAccess
      songs {
        id
      }
    }
  }
`;

export const getSong = gql`
  query GetSong($id: ID!) {
    song(input: { id: $id }) {
      id
      title
      artist
      bpm
      songKey
      notes
      trackNumber
      albumArtworkSmUrl
      albumArtworkMdUrl
      albumArtworkLgUrl
      albumArtworkUrl
      albumArtworkCdnUrl
      shareLinkCreatedAt
      shareLink
      shareLinkAccess
      shareLinkViews
      versionCount
      defaultArtwork
      lyrics
      about
      releaseDate
      primaryHex
      secondaryHex
      options {
        allowReactions
        showAbout
        showReleaseDate
        showLyrics
        showAudioAnalysis
        aiAudioAnalysis
        aiLyrics
      }
      files {
        title
        optimizedUrl
        cdnUrl
        downloadUrl
        id
        active
        notes
        originalFilename
        created
        status
        bpm
        bpmCalculationStatus
        key
        keyScale
        keyCalculationStatus
      }
    }
  }
`;

export const shareLink = gql`
  query ShareLink($id: ID!) {
    shareLink(id: $id) {
      id
      sharedPlaylist {
        title
        description
        access
        albumArtworkUrl
        defaultArtwork
        songs {
          title
          artist
          access
          streamUrl
          optimizedStreamUrl
          defaultArtwork
          albumArtworkUrl
          downloadUrl
        }
      }
      sharedSong {
        title
        artist
        access
        bpm
        songKey
        about
        lyrics
        releaseDate
        options {
          allowReactions
          showAbout
          showReleaseDate
          showLyrics
          showAudioAnalysis
          aiAudioAnalysis
          aiLyrics
        }
        streamUrl
        optimizedStreamUrl
        defaultArtwork
        albumArtworkUrl
        downloadUrl
      }
    }
  }
`;

export const getUserInfo = gql`
  query {
    userInfo {
      userId
      totalStorage
      subscribed
      subscriptionType
      subscriptionSource
      searchKey
      totalSongs
      dismissedMarUpdateId
    }
  }
`;

export const getMarketingUpdates = gql`
  query GetMarketingUpdates($startKey: JSONObject) {
    marketingUpdates(startKey: $startKey) {
      marUpdateId
      primaryCtaUrl
      primaryCtaUrlType
      secondaryCtaType
    }
  }
`;
